import * as React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Loader2 } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export const ClientSelector = ({ value, onValueChange }) => {
  const [clients, setClients] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    const fetchClients = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const response = await axios.get(`${API}/clients`);
        setClients(response.data);
      } catch (err) {
        console.error("Error fetching clients:", err);
        setError("Error al cargar clientes");
      } finally {
        setIsLoading(false);
      }
    };
    fetchClients();
  }, []);

  if (error) {
    return (
      <div className="w-full h-11 flex items-center px-3 border border-red-200 rounded-md bg-red-50 text-red-600 text-sm">
        {error}
      </div>
    );
  }

  return (
    <Select value={value} onValueChange={onValueChange} disabled={isLoading}>
      <SelectTrigger 
        className="w-full bg-white border-slate-200 hover:border-slate-300 h-11"
        data-testid="client-selector-trigger"
      >
        {isLoading ? (
          <div className="flex items-center gap-2 text-slate-400">
            <Loader2 className="h-4 w-4 animate-spin" />
            Cargando clientes...
          </div>
        ) : (
          <SelectValue placeholder="Seleccionar cliente..." />
        )}
      </SelectTrigger>
      <SelectContent>
        {clients.map((client) => (
          <SelectItem 
            key={client.cliente} 
            value={client.cliente}
            data-testid={`client-option-${client.cliente}`}
          >
            {client.cliente} ({client.account_count} cuentas)
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
